var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "h2",
        {
          staticClass: "title font-weight-regular mb-3"
        },
        [_vm._v(_vm._s(_vm.config.heading))]
      ),
      _c(
        "gg-card",
        [
          _c("gg-card-text", [
            _c(
              "div",
              {
                staticClass: "feature-setup text-center py-8 px-4"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "feature-setup__icon mx-auto mb-4"
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          "aria-hidden": "true"
                        }
                      },
                      [_vm._v(_vm._s(_vm.config.icon))]
                    )
                  ],
                  1
                ),
                _c(
                  "h3",
                  {
                    staticClass: "subtitle-1 font-weight-bold mb-1"
                  },
                  [_vm._v(_vm._s(_vm.config.title))]
                ),
                _c(
                  "p",
                  {
                    staticClass: "body-2 text--secondary mb-5"
                  },
                  [_vm._v(_vm._s(_vm.config.description))]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: ""
                    },
                    on: {
                      click: function click($event) {
                        return _vm.$emit("create")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.config.action))]
                ),
                _vm.config.learnMore
                  ? _c(
                      "div",
                      {
                        staticClass: "mt-4"
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "body-2 font-weight-medium feature-setup__link",
                            attrs: {
                              href: _vm.config.learnMore,
                              target: "_blank",
                              rel: "noopener"
                            }
                          },
                          [
                            _vm._v(" Learn more "),
                            _c(
                              "v-icon",
                              {
                                staticClass: "ml-1",
                                attrs: {
                                  small: "",
                                  "aria-hidden": "true"
                                }
                              },
                              [_vm._v("mdi-open-in-new")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }